module.exports = __webpack_public_path__ + "img/marketing.8b4e7717.png";